export const getGroupPictureOriginal = (
  groupId: string | undefined,
  version?: number | string
): string | undefined => {
  if (!groupId) return undefined;
  const STORAGE_BASE_URL = "https://firebasestorage.googleapis.com/v0/b";
  const GROUP_PICTURES_FOLDER = "group-pictures";
  const ORIGINAL_FILENAME = "original.jpeg";
  const BUCKET = process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET;

  return `${STORAGE_BASE_URL}/${BUCKET}/o/${encodeURIComponent(
    `${GROUP_PICTURES_FOLDER}/${groupId}/${ORIGINAL_FILENAME}`
  )}?alt=media${version ? `&v=${version}` : ""}`;
};
